import createUseStyles from '@picsart/rc/create';

const useNavigationStyles = createUseStyles(
  {
    root: {},
    navList: {
      listStyle: 'none',
      padding: '0',
      textAlign: 'center',
    },
  },
  { name: 'navigation' },
);

export default useNavigationStyles;
